$(document).ready(function(){
   
   
   $('.ext__list__item').live('click', function(e){
      e.stopPropagation();
      var $checkbox = $(this).find('input');
      if (e.target.nodeName != 'INPUT')
      if ($checkbox.is( ":checked" )){
          $checkbox[0].checked = false;
      } else {
          $checkbox[0].checked = true;
      }
   });
    $('.ext__list__item input').live('click', function(e){
      //e.preventDefault();
     // setTimeout(function(){
         // $(this)[0].checked = true;
        //  console.log('true');
     // },150)
      
   });
   function hideScroll(){
       $('body, html').css('overflow-y', 'hidden');
   } 
   function showScroll(){
       $('body, html').css('overflow-y', 'auto');
   }
   
$('.boxplus-thumbs').live('mouseover', function(){
    $(this).find('ul').css('visibility', 'visible');
    $(this).find('.boxplus-rewind').css('visibility', 'visible');
    $(this).find('.boxplus-forward').css('visibility', 'visible');
})
$('.boxplus-thumbs').live('mouseout', function(){
   $(this).find('ul').css('visibility', 'hidden');
       $(this).find('.boxplus-rewind').css('visibility', 'hidden');
    $(this).find('.boxplus-forward').css('visibility', 'hidden');
});

$('.cboxElement, .cboxElement img, #imglist2 > li').live('click', function(){
    hideScroll();
    //console.log('hide cBox')
});
$('#cboxOverlay, .boxplus-background, .boxplus-close').live('click', function(){
    showScroll();
    //console.log('show cboxclose');
});

$('.zoom-map, #tab_map').live('click', function(){
    $(".leaflet-left:not(.leaflet-google-mutant), .leaflet-bottom.leaflet-right").show();
   $('#tab_map').addClass('make-modal');
   $('.make-modal-close').css('display','block');
   $(window).trigger('resize');
    if (typeof karta == "undefined") {
    }
   karta.map.invalidateSize();
   hideScroll();
});
$('.make-modal-close').on('click', function(){


    hideBigMap();

    karta.map.invalidateSize();
    if (!karta.searchCenter) return;

    var latLngs = [ karta.searchCenter.getLatLng() ];
    var markerBounds = L.latLngBounds(latLngs);
    karta.map.fitBounds(markerBounds);
});
$('#tab_map').on('click', function(e){
   //console.log(e.target.id);
   if (e.target.id == 'tab_map' && $('#tab_map').hasClass('make-modal')){
       karta.map.invalidateSize();
     // hideBigMap();
   };
});
function hideBigMap(){
    setTimeout(function() {
        $(".leaflet-left:not(.leaflet-google-mutant), .leaflet-bottom.leaflet-right").hide();
    }, 50);

    showScroll();
    $('#tab_map').removeClass('make-modal');
   $('.make-modal-close').css('display','none');
   $(window).trigger('resize');
}
$(document).on('click', function(event){
       if(!$(event.target).closest('#cboxClose').length) {

       } else {
           showScroll();
       }
});
$('.group label').on('click', function(){
   $(this).prev().prev().prev().focus();
});
$('.scroll-top').on('click', function(){
    var body = $("html, body");
body.stop().animate({scrollTop:0}, 400, 'swing', function() { 
});
});

});